<template>
  <vue-ueditor-wrap v-model="content" @ready="ready" :config="myConfig"></vue-ueditor-wrap>
</template>
<script>
  import Vue from "vue";
  import { Loading } from 'element-ui';
  import $ from "jquery";
  import VueUeditorWrap from 'vue-ueditor-wrap'
  import hUrl from "@/utils/url";
  const OSS = require('ali-oss');
  export default {
    name: 'MyRichText',
    model: {
      prop: 'value',
    },
    props: {
      uploadapply: {
        type: [Object],
        default(){
          return {dist: 'aliyun'};
        }
      },
      value: {type: [String]}
    },
    components: {
      VueUeditorWrap
    },
    data(){
      var id = Number(new Date());
      var def = this.getDefData();
      return {
        ossparam: {},
        useoss: false,
        content: this.value,
        uploadUrl: def.uploadUrl,
        myConfig: {
          toolbars: [[
            'fullscreen', 'source', '|', 'undo', 'redo', '|',
            'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
            'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
            'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
            'directionalityltr', 'directionalityrtl', 'indent', '|',
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
            'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
            'simpleupload', 'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', 'map', 'gmap', 'insertframe', 'insertcode', 'webapp', 'pagebreak', 'template', 'background', '|',
            'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
            'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
            'print', 'preview', 'searchreplace', 'drafts', 'help'
          ]],
          BaseUrl: '',
          UEDITOR_HOME_URL: '/static/UEditor/',
          serverUrl: '',
          autoHeightEnabled: false,
          autoFloatEnabled: false,
          elementPathEnabled: false,
          initialFrameHeight: 500,
          initialFrameWidth: '100%',
          multiple: true,
          imgmaxsize:500*1000,//500kb
          customBeforeUpload:(input, file, cbk) => {
            var $el = $(input);
            if(file.type.indexOf('image/')>-1&&file.size>this.myConfig.imgmaxsize){
              this.error('{1}大于500kb'.format(file.name));
              return false;
            }
          },
          customUpload: (input, file, cbk) => {
            var $el = $(input);
            this.editorUpload(file, $el, {}, cbk);
          },
          customLoading:(show)=>{
              if(show){
                Loading.service({lock: true,fullscreen: true});
              }else{
                Loading.service({lock: true,fullscreen: true}).close();
              }
          }
        }
      }
    },
    watch: {
      content(){
        this.$emit('input', this.content);
      }
    },
    methods: {
      ready (editorInstance) {
        this.$watch('value', (a, b, c) => {
          this.content = a;
        })
      },
      client(){
        var client = new OSS(this.ossparam);  //后端提供数据
        return client;
      },
      ossUpload(option) {
        var that = this;
        var fileName = '' + option.file.uid;
        var reader = new FileReader();
        reader.onload = (e) => {
//          console.log(e.target.result);
          this.client().multipartUpload(fileName, this.convertToBlob(e.target.result, option.file.type), {
              progress: function (p) { // 获取进度条的值
                option.onProgress({percent: p * 100});
              }
            }
          ).then(
            result => {
              if (result.res.statusCode === 200) {
                let url = result.res.requestUrls[0]
                url = url.indexOf('?') > 0 ? url.substring(0, url.indexOf('?')) : url; //过滤掉url中的参数部分
                option.onSuccess({data: {url: url}});
              } else {
                option.onError("上传失败");
              }
            })
        }
        // 传入一个参数对象即可得到基于该参数对象的内容
        reader.readAsArrayBuffer(option.file);
      },
      convertToBlob(buffer, type) {
        return new Blob([buffer], {type: type});
      },
      handleBeforeUpload(){
        if (this.useoss) {
          $.ajax({
            type: "post",
            url: hUrl + 'common/upload/security-visit',
            cache: false,
            async: false,
            timeout: 10000,//10秒超时
            success: (res) => {
              if (res.code == 200) {
                this.uploadUrl = res.data.url || "";
                this.ossparam.region = "oss-cn-beijing";
//              this.ossparam.endpoint="https://oss-cn-beijing.aliyuncs.com";
                this.ossparam.bucket = "yunqiaoke";
                this.ossparam.accessKeyId = this.getFieldVal(res.data, 'Credentials.AccessKeyId');
                this.ossparam.accessKeySecret = this.getFieldVal(res.data, 'Credentials.AccessKeySecret');
                this.ossparam.expiration = this.getFieldVal(res.data, 'Credentials.Expiration');
                this.ossparam.stsToken = this.getFieldVal(res.data, 'Credentials.SecurityToken');
              }
            },
            error: (e) => {
              this.msg('请求上传地址出错,使用旧上传地址' + this.uploadUrl, 'error');
            }
          });
        }
      },
      editorUpload(file, $el, data, cbk) {
        //创建FormData对象，初始化为form表单中的数据。需要添加其他数据可使用formData.append("property", "value");
        var formData = new FormData();
        var fileData = {};
        formData.append("file", file);
        formData.append("dist", "aliyun");
        fileData.name = file.name;
        fileData.size = file.size;
        fileData.type = file.type;
        $.each(data, function (i, v) {
          formData.append(i, v);
        });
        $.each(this.uploadapply, function (i, v) {
          formData.append(i, v);
        });
        file.uid = Number(new Date());
        if (this.useoss) {
          this.handleBeforeUpload();
          this.ossUpload({
            file: file,
            onProgress: () => {
            },
            onSuccess: (result) => {
              cbk({state: 'SUCCESS', url: result.data.url, style: 'max-width: 95%'})
            },
            onError: (msg) => {
              this.msg(msg);
            }
          })
        } else {
          //ajax异步上传
          $.ajax({
            url: this.uploadUrl,
            type: "POST",
            data: formData,
            error: function () {
              var a = 3;
            },
            success: function (result) {
              cbk({state: 'SUCCESS', url: result.data.url, style: 'max-width: 95%'})
            },
            // async: true,//必须为true，才会有进度，此时会有个两个请求，一个上传一个取进度，默认是true
            contentType: false, //必须false才会自动加上正确的Content-Type
            processData: false  //必须false才会避开jQuery对 formdata 的默认处理
          });
        }

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MyRichText.vue